import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'crop-1-1', 'Crop11', [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12"}]]);